'use strict';

var React = require('react');

var SvgCaretUpMinor = function SvgCaretUpMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.24 11.8a.75.75 0 0 0 1.06-.04l2.7-2.908 2.7 2.908a.75.75 0 1 0 1.1-1.02l-3.25-3.5a.75.75 0 0 0-1.1 0l-3.25 3.5a.75.75 0 0 0 .04 1.06Z"
  }));
};
SvgCaretUpMinor.displayName = "CaretUpMinor";

exports.SvgCaretUpMinor = SvgCaretUpMinor;
